import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDriverScoreYears } from '../../services/DriversService';
import { DriverScoreYears } from '../../types/Drivers';
import { FeaturesManagement } from '../../../featuresControl';

function useGetDriverScoreYears(
  id: string,
  fleetId: string,
  from: number,
  to?: number,
): UseQueryResult<DriverScoreYears> {
  return useQuery(
    ['driver-score-years', id, fleetId, from, to],
    async (): Promise<DriverScoreYears> => getDriverScoreYears(id, fleetId, from, to),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      enabled: !!id && !!from,
    },
  );
}

export default useGetDriverScoreYears;
